define('common/bargain', [
    'jquery',
    'data/intent',
    'widget/dialog/success',
    'log',
    'common/util',
    'data/wechat-entry',
    'jquery.cookie',
], ($, intent, dialog, log, util, wechat) => {
    const ndBargainModalGlobal = $('#bargain_modal');

    function init() {
        // 线索提交下法务提示
        util.intentLawHandle($('#js-dialog-provision-select'), $('#bargain_submit'));

        // TODO: 这里的代码需要重构
        // 在传递数据时，由于列表页不同车提交的不一样，在点击事件后把data传递到按钮上了
        // 而详情页的数据是从页面的某些节点取得的，逻辑有所不同。日后重构需要注意
        $('#bargain_submit').on('click', function () {
            const $provisionSelect = $('#js-dialog-provision-select');
            // 解决js单测问题
            if ($provisionSelect[0]) {
                const state = $provisionSelect.hasClass('selected');
                if (!state) return;
            }
            const ndBargainModal = $('#bargain_modal');
            const $inMobile = $('#bargain_mobile_number');
            const phone = $.trim($inMobile.val());
            const $inPhoneSource = $('#bargain_phone_source');
            const $price = $('#bargain_new_price');
            const $oldPrice = $('#bargain_old_price');
            const val = $.trim($price.val());

            if (val === '' || isNaN(val)) {
                $price.addClass('error');
                $price.parent().children('p[class="error"]').html('*您输入的价格不正确');
                return;
            }
            $price.removeClass('error');
            $price.parent().children('p[class="error"]').html('');

            if (!util.isMobile(phone)) {
                $inMobile.addClass('error');
                $inMobile.parent().children('p[class="error"]').html('*手机号格式不正确');
                return;
            }
            $inMobile.removeClass('error');
            $inMobile.parent().children('p[class="error"]').html('');
            const nowPrice = $price.val();
            let oldPrice = parseFloat($oldPrice.val());
            let carId = $('.detail-wrapper').data('id');
            let source = $inPhoneSource.val();
            const price = $price.val();
            const type = 'PC';

            // 列表页和首页，会把车辆数据写到提交按钮上, 在这里覆盖这几个数据
            if ($(this).data('car-id')) {
                carId = $(this).data('car-id');
                source = $(this).data('phone-source');
                oldPrice = $(this).data('old-price');
            }

            // 价格不正确
            if (nowPrice <= 0) {
                $price.parent().children('p[class="error"]').html('*您输入的价格不正确');
                return;
            }

            // 您输入的价格已高于原价啦
            if (nowPrice > oldPrice) {
                $price.addClass('error');
                $price.siblings('p[class="error"]').html('*出价已经高于原价啦');
                log.push(['_trackEvent', 'pc_detail_bargain_error', 'click', `car_id_${carId}`]);
                return;
            }
            $price.removeClass('error');
            $price.siblings('p[class="error"]').html('');

            const data = {
                car_id: carId,
                phone,
                source,
                price,
                type,
                owner_price: oldPrice,
            };
            ndBargainModal.fullscreen('hide');
            intent('bargain', data, (json) => {
                const status = parseInt(json.status, 10);
                if (status === 0) {
                    if (RRC.pageName === 'car-detail') {
                        RRC.SHOW_DETAIL_LAYER_MASK = false;
                    }
                    $('#bargain_mobile_number').val('');
                    $('#bargain_new_price').val('');
                    let bargainMessage = '';
                    if (util.isSpring()) {
                        bargainMessage = util.getPCIntentSuccessTips('kanjia');
                        if (Array.isArray(bargainMessage)) {
                            bargainMessage = bargainMessage.map(item => `<p style="margin-bottom: 5px;">${item}</p>`).join('');
                        }
                        bargainMessage = `<div class="confirm__message">${bargainMessage}</div>`;
                    } else {
                        bargainMessage = json.notice_message;
                    }
                    dialog('提交成功', bargainMessage, '/dist/images/default-qr-b2621fb1.png');
                } else if (status === 100) {
                    ndBargainModal.fullscreen('show');
                    $('#bargain_new_price').val('').focus();
                    ndBargainModal.find('.dialog-message').html(json.notice_message);
                    ndBargainModal.find('.dialog-title').html('您的出价有点低哦');
                } else {
                    $('#bargain_mobile_number').val('');
                    $('#bargain_new_price').val('');
                }
            }, '/dist/images/default-qr-b2621fb1.png');
        });
    }

    function showBargainModal() {
        $('.bargain-error').hide();
        ndBargainModalGlobal.find('.dialog-title').html('请输入您的期望价格');
        if ($('.error').length !== 0) {
            $('#bargain_new_price').val('').removeClass('error').css('font-size', '14px');
            $('#bargain_new_price').parent().children('p[class="error"]')
                .html('');
        }
        if ($('.error').length !== 0) {
            $('#bargain_mobile_number').val('').removeClass('error');
            $('#bargain_mobile_number').parent().children('p[class="error"]')
                .html('');
        }

        // 已登录则自动添加手机号
        const phone = $.cookie('rrc_login_phone');
        if (phone) {
            $('#bargain_mobile_number').val(phone);
        }

        ndBargainModalGlobal.fullscreen({
            backdrop: 'static',
            show: true,
        });
    }

    // 初始化首页, 列表页和知心页面的砍价操作
    function initCarListBargain() {
        if (!util.isFromBdOther()) {
            return false;
        }
        init();
        $('.js-bargain').on('click', function (e) {
            wechat.replaceAppointment('2701');
            const ndBargainBtn = $('#bargain_submit');
            const oldPrice = $(this).data('old-price');
            $('#bargain_modal .dialog-message').html('车主报价：<span class="price"></span>万');
            e.preventDefault();
            // 把数据放在按钮上
            ndBargainBtn.data({
                'car-id': $(this).data('car-id'),
                'phone-source': $(this).data('phone-source'),
                'old-price': $(this).data('old-price'),
            });
            showBargainModal();
            // 修改弹窗中车主报价
            if (oldPrice) {
                $('#bargain_modal .dialog-message .price').html(parseFloat(oldPrice).toFixed(2));
            }
        });
    }

    return {
        init,
        show: showBargainModal,
        initCarListBargain,
    };
});
